module.exports = __webpack_public_path__ + "svg/burger-icon.svg?19f949c4fec14b2e26192988ec54ea80";